import { SaleSetAddMultipleRequest, SaleSetDeleteItemRequest, SaleSetKhoanNopSaveChangeRequest, SaleSetSaveChangeRequest, SaleSetAddMultipleStudentsRequest, SaleSetHideItemsRequest } from '../models/request/sale-set/SaleSetSaveChangeRequest';
import { ISalseSetSelectByStudentRequest } from './../models/request/sale-set/SaleSetSelectByStudentRequest';
import { apiClient } from './apiClient';

export interface ISaleSetSyncRequest {
    nam_hoc: string;
    dm_truong_id?: number;
    dm_khoi_id?: number;
    dm_he_id?: number;
    ts_hocsinh_ids?: number[];
    dm_truong_ids?: number[];
    dm_khoi_ids?: number[];
    dm_he_ids?: number[];
}

export const saleSetApi = {
    selectByStudent: (request: ISalseSetSelectByStudentRequest) => apiClient.post("uf_saleset/select_by_student", request),
    saveChanges: (request: SaleSetSaveChangeRequest) => apiClient.post("uf_saleset/savechanges", request),
    selectKhoanNopGroupByStudent: (request: ISalseSetSelectByStudentRequest) => apiClient.post("uf_saleset/khoan_nop_group/select", request),
    saveChangesKhoanNopGroup: (request: SaleSetKhoanNopSaveChangeRequest) => apiClient.post("uf_saleset/khoan_nop_group/save", request),
    sync: (request: ISalseSetSelectByStudentRequest) => apiClient.post("uf_saleset/sync", request),
    syncByFilter: (request: ISaleSetSyncRequest) => apiClient.post("uf_saleset/sync_by_filter", request),
    syncCongNo: (request: ISaleSetSyncRequest) => apiClient.post("uf_saleset/sync_cong_no", request),
    syncCongNoProgress: (jobId: string) => apiClient.get(`uf_saleset/sync_cong_no_progress?jobId=${jobId}`),
    // Thêm nhiều khoản vào saleset cho học sinh (chỉ thêm nếu định mức > 100)
    addMultiple: (request: SaleSetAddMultipleRequest) => apiClient.post("uf_saleset/add_multiple", request),
    deleteItem: (request: SaleSetDeleteItemRequest) => apiClient.post("uf_saleset/delete_item", request),
    hideItems: (request: SaleSetHideItemsRequest) => apiClient.post("uf_saleset/hide_items", request),
    // Thêm nhiều khoản vào saleset cho nhiều học sinh cùng lúc
    addMultipleStudents: (request: SaleSetAddMultipleStudentsRequest) => apiClient.post("uf_saleset/add_multiple_students", request)
}